export default "__VITE_ASSET__Bxhe$nNa__"